// extracted by mini-css-extract-plugin
module.exports = {"container":"ExoIrisPhoneSequence_container__oUw5b"};